import React, { useRef, useCallback, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import 'swiper/css';
import Carousel from 'react-bootstrap/Carousel';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ProductCard } from '../Common';
import 'swiper/css/grid';
import { Grid } from "swiper/modules";
import { MediaQueries } from '../utils';
import { motion } from 'framer-motion';
import CarouselProducts from './CarouselProducts';
import { NavLink } from 'react-router-dom';
import TopPicksCarouselProducts from './TopPicksCarouselProducts';
function TopPicks({ carousel_data }) {
    const sliderRef = useRef(null);
    const { isMobile, isTablet } = MediaQueries();
    const [index, setIndex] = useState(0);

    const [data, setData] = useState([]);


    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex)
        setTimeout(() => {
            if (carousel_data[selectedIndex].productlist != undefined) {
                setData(carousel_data[selectedIndex].productlist);
            } else {
                setData([])
            }
        }, 300); // 3 seconds
    };


    useEffect(() => {
        if (carousel_data[0].productlist != undefined) {
            setData(carousel_data[0].productlist)
        } else {
            setData([])
        }
    }, [carousel_data])

    return (
        <Row>
            <Col lg={3} className='padding_custom'>
                <Carousel fade className='home_carousel top_picks_carousel' indicators={false} activeIndex={index} onSelect={handleSelect}>
                    {
                        carousel_data.map((item) => {
                            return (
                                <Carousel.Item key={item.brand_id}>
                                    <img src={item.image_slider} alt='' style={{ borderRadius: 16, height: 325 }} />
                                </Carousel.Item>
                            )
                        })
                    }
                </Carousel>
                {
                    isTablet &&
                    <>
                        <div class="track_indicators">
                            {
                                carousel_data.map((indicator_item, index1) => {
                                    return (
                                        <motion.div
                                            layout
                                            data-isOpen={index == index1}
                                            initial={{ borderRadius: 50 }}
                                            className="indicator"
                                            onTap={() => setIndex(index1)}
                                        />
                                    )
                                })
                            }
                        </div>
                    </>
                }
            </Col>
            <Col lg={9} className={isTablet && 'mt-3'}>
                {
                    isTablet ?
                        <Swiper
                            ref={sliderRef}
                            effect={'fade'}
                            modules={[Grid]}
                            grid={{ rows: isTablet && 4, fill: "row" }} // 2 rows
                            breakpoints={{
                                200: {
                                    slidesPerView: 2,
                                },
                                450: {
                                    slidesPerView: 2,
                                },
                                760: {
                                    slidesPerView: 3,
                                },
                                1000: {
                                    slidesPerView: 2.5,
                                },
                                1200: {
                                    slidesPerView: 3,
                                },
                                1400: {
                                    slidesPerView: 4,
                                },
                                1600: {
                                    slidesPerView: 4,
                                }
                            }}
                            spaceBetween={isMobile ? 8 : 15}
                            className="carouselSwiper"
                        >
                            {
                                data.map((item) => {
                                    return (
                                        <SwiperSlide >
                                            <NavLink to={`/details/${item.url}/${item.sku}`} className={'text-decoration-none'}>
                                                <ProductCard item={item} />
                                            </NavLink>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                        :
                        <TopPicksCarouselProducts products={data} type={3} inner_bg={'rgba(238, 235, 250, 1)'} />
                }

            </Col>
        </Row>
    );
}

export default TopPicks;